/*
 * @Description:
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2021-10-08 15:06:27
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-03-25 14:04:23
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import tim from './tim'
import TIM from 'tim-js-sdk/tim-js-friendship.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import api from './api/index'
import {genTestUserSig} from './utils/index'
import YButton from '@/components/YButton'
import MetaInfo from 'vue-meta-info'
import pattern from './utils/pattern'
import status from './utils/status'
import common from './utils/common'
import BuriedPoint from './utils/buried-point'
import {formatDate,copy,getUrlByWechat} from './utils/index'
import AvatarCropper from 'vue-avatar-cropper'
import "babel-polyfill"
import NewbieGuide from './components/newbieGuide/'
import ChoosePayType from './components/ChoosePayType'
import addressInfo from './views/servicePackage/components/OrderCard'
import addressPopup from './views/address/dialog'

import './assets/css/custom.css'



Vue.use(Vant);
Vue.use(MetaInfo);//自定义title]
window.tim = tim
window.TIM = TIM
Vue.component("YButton", YButton);
Vue.component('AvatarCropper', AvatarCropper);
Vue.component('NewbieGuide', NewbieGuide);
Vue.component('ChoosePayType', ChoosePayType);
Vue.component('addressInfo',addressInfo)
Vue.component('addressPopup',addressPopup)
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
Vue.prototype.$bus = new Vue()
Vue.prototype.genTestUserSig = genTestUserSig
Vue.prototype.api = api
Vue.prototype.$pattern = pattern
Vue.prototype.formatDate = formatDate
Vue.prototype.$status = status
Vue.prototype.$common = common
Vue.prototype.$copy = copy
Vue.prototype.getUrlByWechat = getUrlByWechat
Vue.prototype.$buriedPoint = BuriedPoint.init({
  app_channel: 'wechat',
  app_name: 'medical_plus'
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js